import type { TreeData } from '../../components/tree/useTreeApi';
import type { TaxonomyLevelMetadata } from './taxonomyTree';
import {
  type ParentLinkedItem,
  treeToParentLinkedSelectionLists,
} from './treeToParentLinkedSelectionLists';

/**
 * Geography variant of `treeToParentLinkedSelectionLists`.
 *
 * The geography taxonomyTree tags its metro level `metro_area` and its city
 * level `city_core`, but consumers (and the FE selection-list types) key these
 * off the canonical `msa` / `city`. Expose the tree levels under those keys —
 * falling back to the legacy `msa` / `city` tags so a tree still using the old
 * naming keeps working. `region` / `country` / `state` pass through unchanged.
 */
export const treeToGeoSelectionLists = (
  treeData: readonly TreeData[],
  levels: readonly TaxonomyLevelMetadata[]
): Partial<Record<string, ParentLinkedItem[]>> => {
  const linked = treeToParentLinkedSelectionLists(treeData, levels);
  const msa = linked.metro_area ?? linked.msa;
  const city = linked.city_core ?? linked.city;
  return {
    ...linked,
    ...(msa ? { msa } : {}),
    ...(city ? { city } : {}),
  };
};
